import { GeoLocation, PagedFilter } from '../common/common.types';

export enum MetaStatus {
	Pending = 0,
	Active = 1,
	Archived = 2
}

export class EventOccasion {
	eventOccasionId: number;
	name: string;
}

export class EventVertical {
	eventVerticalId: number;
	abbreviation: string;
	name: string;

	email?: string;
	phone?: string;
	contactDetails?: EventVerticalContactDetails[];
}

export class EventVerticalContactDetails {
	currencyCode: string;
	email?: string;
	phone?: string;
}

export class EventType {
	eventTypeId: number;
	eventVerticalId: number;
	abbreviation: string;
	name: string;
	location?: GeoLocation;
	timezone?: string;
}

export class EventTypeDetails {
	eventTypeId: number;
	abbreviation: string;
	name: string;
	location?: GeoLocation;
	timezone?: string;
	status: MetaStatus;
	currencyCode: string;
	eventVertical: EventVerticalSummary;
}

export class EventTypeWM {
	abbreviation: string;
	name: string;
	eventVerticalId: number;
	location?: GeoLocation;
	timezone?: string;
	status: MetaStatus;
	currencyCode: string;
}

export class EventVerticalSummary {
	eventVerticalId: number;
	abbreviation: string;
	name: string;
}

export class EventTypeFilter extends PagedFilter {
	eventVerticalIds?: number[];
	statuses?: MetaStatus[];
	searchTerm?: string;
}

export class ActivityType {
	activityTypeId: number;
	name: string;
	hasCost: boolean;
	hasDuration: boolean;
	hasStatus: boolean;
}

export class ActivityTypeFilter {
}
